import React, { useEffect, useState } from 'react';
import './styles.css';

const fetchIP = async () => {
    try {
        const response = await fetch('https://checkip.amazonaws.com/');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const ip = (await response.text()).trim();
        return ip;
    } catch (error) {
        console.error('Error fetching IP:', error);
        return '';
    }
};

const App = () => {
    const [ip, setIp] = useState('');
    const [copied, setCopied] = useState(false);
    const [copiedCIDR, setCopiedCIDR] = useState(false);

    useEffect(() => {
        const getIP = async () => {
            const ipAddress = await fetchIP();
            setIp(ipAddress);
        };

        getIP();
    }, []);

    const handleCopy = async () => {
        if (ip) {
            await navigator.clipboard.writeText(ip);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }
    };

    const handleCopyCIDR = async () => {
        if (ip) {
            await navigator.clipboard.writeText(ip + '/32');
            setCopiedCIDR(true);
            setTimeout(() => setCopiedCIDR(false), 1500);
        }
    };

    return (
        <div className="app">
            <h1>What is my IP?</h1>
            <p>
                Your public IP address is: <br /><strong>{ip}</strong>
                {ip && (
                    <>
                        <button
                            className="copy-btn"
                            onClick={handleCopy}
                            style={{ marginLeft: '8px' }}
                            title="Copy IP to clipboard"
                        >
                            📋
                        </button>
                        {copied && <span style={{ marginLeft: '8px', color: 'green' }}>Copied!</span>}
                        <button
                            className="copy-btn"
                            onClick={handleCopyCIDR}
                            style={{ marginLeft: '8px' }}
                            title="Copy IP/32 to clipboard"
                        >
                            📋/32
                        </button>
                        {copiedCIDR && <span style={{ marginLeft: '8px', color: 'green' }}>Copied!</span>}
                    </>
                )}
            </p>
        </div>
    );
};

export default App;